import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IWithPermissionModel} from '../../../common/permission/api/entity/iWithPermission.model';

@Component({
  selector: 'app-action-link',
  templateUrl: './action-link.component.html',
  styles: [
  ]
})
export class ActionLinkComponent implements OnInit {
  @Input() disabled = false;
  @Output() clickEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  constructor() { }

  ngOnInit(): void {
  }

  click(mouseEvent: MouseEvent) {
    if (!this.disabled) {
      this.clickEvent?.emit(mouseEvent);
    }
  }

}
